import { RowNode } from "ag-grid-community";
import { CRUD, QueovalBase } from "..";
import { ClickedElement } from "../../avatar-search";
import { BObjectModel } from "../bodisplay";
import { GenericEffectif } from "./genericEffectif.model";
import { InfoLienEffectifs } from "./infoLienEffectifs.model";
import { DataType, ModeEffectifUpdate, RenderType } from "./option.model";

export class EffectifModel extends QueovalBase {
  // Liste des effectifs à afficher
  public DataListAll: Array<GenericEffectif>;

  public DataListSelect: Array<GenericEffectif>;

  public DataListCycles: Array<GenericEffectif>;

  public DataListFilter: Array<GenericEffectif>;

  AllData: DataEffectif; 

  SelectedData: DataEffectif;

  public PereData: DataEffectif;

  FilteredData: DataEffectif;
   
  //Permet de choisir le type de rendu des effectifs soit PM soit PP
  public RenderType: RenderType;

  public DataType: DataType;

  public IdEffectifToComment: string = "";

  public IdEffectifToMove: string;

  public ListIdEffectifsToMove: Array<string>;

  // permet d'afficher ou pas le bouton et la liste des données liées aux cycles
  public Cycles: boolean;

  public IsAffectedToCycles: boolean;

  public ModelBo: BObjectModel;

  public IsContactPrincipal: boolean = false;

  public NombreEffectif: number;

  public GridFileName: string;

  public InfoLiens: Array<InfoLienEffectifs> = new Array<InfoLienEffectifs>();

  public SelectedLines: Array<RowNode>;

  public LstColumnToSave: Array<string>;

  public NeedInfoExtranet: boolean = false;
}

export class DataEffectif {

  // Id origine
  IdOrigin: string;

  // Nom de la colonne de TdoLien pour la récup de donnée
  Origin?: string;

  //Relation
  Relation: string;

  BoName?: string;

  // permet de dire si il s'agit du père ou du fils de la relation
  OriginLink?: string;

  constructor() {

  }
}

//export class ClickedEffectifElement<T> extends ClickedElement<T> {
//  constructor(pElements: T[], pAction: CRUD, pRenderType: RenderType, pShowCycle: boolean) {
//    super(pElements, pAction);
//    switch (pRenderType) {
//      case RenderType.PP:
//      case RenderType.PPPHOTO:
//        if (pShowCycle && pAction == CRUD.CREATE) {
//          this.updateMode = ModeEffectifUpdate.INSERT_CLIENT_OF_STAGIAIRE;
//        }
//        break;
//      case RenderType.PM:
//        if (pAction == CRUD.CREATE) {
//          this.updateMode = ModeEffectifUpdate.PUSH_CLIENT_IN_FILTER;
//        }
//        else if (pAction == CRUD.DELETE) {
//          this.updateMode = ModeEffectifUpdate.REMOVE_CLIENT_FROM_FILTER;
//        }
//        break;

//    }
//  }
//  public updateMode: ModeEffectifUpdate;
//}


